<template>
    <div class="col mx-2">
        <div class="card bg-danger">
            <div class="card-body text-white pb-0">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="display-3 mb-0">
                        <i class="fas fas fa-ban"></i>
                    </p>
                    <p class="display-4 mb-0">{{ n }}</p>
                </div>
                <h4 class="text-right">Marcados como spam</h4>
            </div>
            <div class="card-footer text-right">
                <slot name='router'></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'n']
    };
</script>
